import { Box } from "@chakra-ui/react";
import { Alert, Button, Modal, Select } from "antd";
import useShipmentCreation, { CreationResult } from "hooks/useShipmentCreation";
import { LegacyShipmentTypes, ShipmentType, ShipmentTypeNames } from "models/shipping";
import { useState } from "react";

const ShipmentTypeOptions =
    Object.entries(ShipmentTypeNames)
        .filter(([v,]) => !LegacyShipmentTypes.includes(Number(v) as ShipmentType)) // exclude shipment types not in use
        .sort(([, a], [, b]) => a.localeCompare(b))                                 // sort by name ascending
        .map(([value, label]) => ({
            label,
            value: Number(value) as ShipmentType
        }));

const ShipmentCreationModal = () => {
    const [visible, setVisible] = useState<boolean>(false);
    const [working, setWorking] = useState<boolean>(false);
    const [result, setResult] = useState<CreationResult | undefined>();
    const [shipmentTypes, setShipmentTypes] = useState<ShipmentType[]>([]);
    const { createShipments } = useShipmentCreation();

    const onOpen = () => {
        setVisible(true);
    }

    const enqueue = async () => {
        setWorking(true);
        const result = await createShipments(shipmentTypes);
        setWorking(false);
        setResult(result);
    }

    const complete = () => {
        setVisible(false);
        if (result && result.successful) {
            window.location.reload();
        }
    }

    return <>
        <Button type="link" size="large" onClick={onOpen}>Create Shipments</Button>
        <Modal
            title="Create Shipments"
            closable={false}
            keyboard={true}
            maskClosable={true}
            destroyOnClose={true}
            open={visible}
            footer={result !== undefined ? (
                <Button key='cancel' type="default" onClick={complete} disabled={working}>Close</Button>
            ) : ([
                <Button key='ok' type="primary" onClick={enqueue} disabled={working}>Create</Button>,
                <Button key='cancel' type="default" onClick={() => setVisible(false)} disabled={working}>Cancel</Button>
            ])}
        >
            <Box mb={5}>
                This will kick off shipment creation in the background, and the process may take some time.
                Current progress will be shown & will update automatically.
            </Box>
            <Box mb={5}>
                <label>Limit Shipment Types To:</label>
                <Select
                    mode="multiple"
                    placeholder="All Shipment Types"
                    style={{ width: '100%', marginTop: '5px' }}
                    options={ShipmentTypeOptions}
                    onChange={setShipmentTypes}
                />
            </Box>
            {working && <Alert
                className="bold-font"
                message="Enqueing shipment creation..."
                type="info"
                showIcon
            />}
            {result && <Alert
                className="bold-font"
                message={result.message}
                type={result.successful ? "success" : "error"}
                showIcon
            />}
        </Modal>
    </>
}

export default ShipmentCreationModal;